import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Message } from '../models/message.model';
import { MessageService } from '../../../core/services/message.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { UnreadMessageService } from '../../../core/services/unread-message.service';
import { InteractionStateService } from '../services/interaction-state.service';
import { SocketConnectionService } from 'app/core/services/socket-connection.service';
import { ConfigService } from 'app/core/services/config.service';
import { InteractionEventType } from '../models/interaction-event-type';

@Component({
  selector: 'cc-chat-interaction-messages',
  templateUrl: './interaction-messages.component.html',
  styleUrls: ['./interaction-messages.component.scss'],
})
export class InteractionMessagesComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('messagesElement') private messageElementRef: ElementRef;

  messages$: Observable<Message[]>;

  destroy$ = new Subject<void>();
  messages: Message[];
  private observer!: IntersectionObserver;
  messageToBeSeenId: number;

  lastQuickReplyMessages: number;
  constructor(
    private messageService: MessageService,
    public unreadMessageService: UnreadMessageService,
    public interactionStateService: InteractionStateService,
    private socketConnectionService: SocketConnectionService,
    public configService: ConfigService,
    private cd: ChangeDetectorRef
  ) {
    this.socketConnectionService.establishWebSocketConnection();
  }

  ngOnInit(): void {
    this.watchForMessages();
  }

  ngAfterViewInit(): void {
    this.scrollToBottom();

    // Set up Intersection Observer to detect component visibility
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.messageService.areMessagesVisible = entry.isIntersecting;
          this.messageService.onVisibilityChange();
        });
      },
      { threshold: 0.1 } // Adjust as needed
    );

    // Start observing the messages component
    this.observer.observe(this.messageElementRef.nativeElement);
  }

  watchForMessages(): void {
    this.messageService.messages$.subscribe((messages) => {
      this.messages = messages;
      this.lastQuickReplyMessages = this.countLastQuickReplies(messages);
      console.log('this.messages', this.messages);
      this.cd.detectChanges();
      this.scrollToBottom();
    });
  }

  countLastQuickReplies(messages: Message[]): number {
    let quickReplyCount = 0;

    // Start from the last message and count backwards
    for (let i = messages.length - 1; i >= 0; i--) {
      const message = messages[i];

      // Stop counting if the message is not a quick reply
      if (!message.isQuickReply) {
        break;
      }

      quickReplyCount++;
    }

    return quickReplyCount;
  }

  scrollToBottom(): void {
    try {
      if (this.messageElementRef) {
        this.messageElementRef.nativeElement.scrollTop =
          this.messageElementRef.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.error(err);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onScroll(event) {
    if (event.target.scrollTop === 0) {
      // Step 1: Capture current scroll position and container height
      const previousScrollHeight =
        this.messageElementRef.nativeElement.scrollHeight;

      // Step 2: Load more history
      this.messageService.loadMoreHistory().then(() => {
        // Step 3: After loading more messages, adjust the scroll position

        const newScrollHeight =
          this.messageElementRef.nativeElement.scrollHeight;
        const scrollDifference = newScrollHeight - previousScrollHeight;
        this.messageElementRef.nativeElement.scrollTop = scrollDifference;
      });
    }
  }
}
